import React, { useEffect, useState } from 'react'
import TextInputRedirect from '../../../components/TextInputRedirect/TextInputRedirect.jsx'
import DOMPurify from 'dompurify'

export const Subsection = ({ page, component, item, params }) => {
  const [parameters, setParameters] = useState({
    displaySubscriptionCenter: null,
    document: null,
    includeTextInputRedirect: null,
    searchLabel: null,
    searchPath: null,
    subscriptionName: null,
  })

  const [blurb, setBlurb] = useState({
    id: null,
    title: null,
    description: null,
    displayName: null,
    name: null,
    sectionLink: null,
    background: null,
    icon: null,
    links: null,
    content: null,
  })

  useEffect(() => {
    const _parameters = params || component.getParameters()
    const _models = component?.getModels() || {}
    const { document: _documentRef } = _models
    const _document = _documentRef && page.getContent(_documentRef)

    setParameters({
      displaySubscriptionCenter: _parameters.displaySubscriptionCenter,
      document: _parameters.document,
      includeTextInputRedirect: _parameters.includeTextInputRedirect,
      searchLabel: _parameters.searchLabel,
      searchPath: _parameters.searchPath,
      subscriptionName: _parameters.subscriptionName,
    })

    if (item) {
      setBlurb(item)
    } else {
      const translatedData = {}

      if (_document) {
        const data = _document.getData()
        translatedData.id = data.id
        translatedData.title = data.title
        translatedData.description = data.description
        translatedData.displayName = data.displayName
        translatedData.name = data.name
        translatedData.sectionLink = data.sectionLink
        translatedData.background = data.background
        translatedData.icon = data.icon
        translatedData.links = data.links
        translatedData.content = data.content
      }

      const {
        id,
        title,
        description,
        displayName,
        name,
        sectionLink,
        background,
        icon,
        links,
        content,
      } = translatedData

      setBlurb({
        id: id,
        title: title,
        description: description,
        displayName: displayName,
        name: name,
        sectionLink: sectionLink,
        background: background,
        icon: icon,
        links: links,
        content: content,
      })
    }
  }, [params, component, page])

  const hasContent = (input) => {
    return input?.length > 0
  }

  return (
    <div
      className="Subsection-container u-sizeConstrained"
      data-qa-automation={blurb.name}
    >
      <div
        className={`Subsection u-bgColorOffwhite u-bgSizeCover ${
          blurb?.background?.image ? 'has-background' : ''
        }`}
        data-analytics-component-name="Subsection"
        {...(blurb?.background?.image && {
          [`style`]: {
            backgroundImage: `url(${page
              .getContent(blurb?.background?.image?.$ref)
              .getOriginal()
              .getUrl()})`,
          },
        })}
      >
        <div className="Subsection-innerWrapper Grid u-marginHoriz0 u-paddingLeft5gu u-paddingVert4gu">
          <div
            className={`u-sm-marginBottom8gu ${
              parameters.includeTextInputRedirect || hasContent(blurb.links)
                ? 'u-md-size4of12 u-lg-size4of12 u-paddingRight5gu'
                : ''
            }`}
          >
            {blurb.icon && (
              <div
                className="Icon Icon--cti Icon--layered u-textSizeMsrp5 u-paddingBottom5gu"
                {...(hasContent(blurb?.icon) && {
                  'data-icon': `${blurb.icon}-top`,
                })}
                aria-hidden="true"
              >
                {blurb.icon}
              </div>
            )}
            <h2>
              <a className="u-textColorDefault" href={parameters.searchPath}>
                {blurb.title}
              </a>
            </h2>
            <div
              className="Content"
              data-description="description"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(blurb.description),
              }}
            />
            {blurb.sectionLink && (
              <div className="u-flex u-flexAlignItemsCenter">
                <p>
                  <a
                    className="u-textBold u-textColorBrand u-textSecondary"
                    href={DOMPurify.sanitize(
                      blurb.sectionLink.link?.[0]?.string
                    )}
                    target={blurb.sectionLink.target}
                  >
                    {hasContent(blurb?.sectionLink?.icon) && (
                      <span
                        className="Icon Icon--cti Icon--layered u-marginRight2gu"
                        {...(hasContent(blurb?.sectionLink?.icon) && {
                          'data-icon': `${blurb.sectionLink.icon}-top`,
                        })}
                        aria-hidden="true"
                      >
                        {blurb.sectionLink.icon}
                      </span>
                    )}
                    {blurb.sectionLink.text}
                  </a>
                </p>
                {parameters?.displaySubscriptionCenter && (
                  <>
                    <span className="u-textDivider"></span>
                    <email-subscription-modal
                      data-use-inline-button="true"
                      data-subscription-name={parameters.subscriptionName}
                    ></email-subscription-modal>
                  </>
                )}
              </div>
            )}
          </div>
          <div className="u-md-size8of12 u-lg-size8of12">
            <div className="Grid Grid--withGutter">
              <div className="text-input-redirect-app">
                {parameters.includeTextInputRedirect && (
                  <TextInputRedirect
                    path={parameters.searchPath}
                    label={parameters.searchLabel}
                  />
                )}
              </div>
              <ul className="Grid Grid--withGutter u-marginBottom3gu">
                {blurb?.links?.length > 0 &&
                  blurb.links.map((link) => {
                    return (
                      <li
                        className="Subsection-linkListItem u-md-size6of12 u-lg-size6of12"
                        key={link.link[0].string}
                      >
                        <a
                          className="LinkList-header u-cf u-textBold"
                          href={DOMPurify.sanitize(link.link[0].string)}
                          target={link.target}
                          data-link-list-item="link-list"
                        >
                          {link.icon && (
                            <span
                              className="Icon Icon--cti Icon--layered u-marginRight3gu u-textSizeMsrp3"
                              data-icon={`${link.icon}-top`}
                              aria-hidden="true"
                            >
                              {link.icon}
                            </span>
                          )}
                          <span
                            className="Icon Icon--cti u-floatRight u-marginRight2gu"
                            aria-hidden="true"
                          >
                            &#xf108;
                          </span>
                          {link.text}
                        </a>
                        {link.description && (
                          <span className="Content u-block u-paddingRight9gu u-textSecondary u-paddingLeft2gu u-paddingBottom3gu">
                            {link.description}
                          </span>
                        )}
                      </li>
                    )
                  })}
              </ul>
            </div>
            {blurb?.content?.value && (
              <div className="Content">{blurb?.content?.value}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
